import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        fontSize: {
            small: typography.fontSize.subtitle,
            medium: typography.fontSize.body,
            large: '16px' /* typography.fontSize.bodyLarge */,
            extraLarge: '16px' /* typography.fontSize.bodyLarge */,
        },
        fontFamily: typography.fontFamily,
        fontWeight: typography.fontWeight.body,
        Input: {
            height: {
                small: '24px',
                medium: '32px',
                large: '40px',
                extraLarge: '48px',
            },
            border: '1px solid',
            borderColor: semantic.component.input.border,
            color: semantic.text.stronger.neutral,
            placeholderColor: semantic.text.neutral,
            borderRadius: {
                small: '6px',
                medium: '8px',
                large: '10px',
                extraLarge: '12px',
            },
            padding: {
                small: '6px 8px',
                medium: '6px 8px',
                large: '6px 12px',
                extraLarge: '6px 12px',
            },
            backgroundColor: semantic.bg.default,
            focus: {
                outline: `2px solid ${semantic.border.primary}`,
                outlineOffset: 2,
            },
        },
        label: {
            color: semantic.text.stronger.neutral,
            fontSize: 12,
            lineHeight: '20px',
            height: 20,
        },
        helperText: {
            color: semantic.text.neutral,
            fontSize: 12,
            lineHeight: '16px',
            paddingLeft: 8,
            height: 16,
        },
        required: {
            color: semantic.text.error,
            fontSize: 14,
            lineHeight: '20px',
            marginLeft: 2,
        },
        optional: {
            color: semantic.text.strong.neutral,
            fontSize: 14,
            lineHeight: '20px',
            fontWeight: 400,
            marginLeft: 2,
        },
        affix: {
            border: '1px solid',
            borderColor: semantic.component.input.border,
            padding: {
                small: '6px 8px',
                medium: '6px 8px',
                large: '6px 12px',
                extraLarge: '6px 12px',
            },
            backgroundColor: semantic.bg.default,
        },
        hover: {
            backgroundColor: semantic.state.subtle.neutral.hover,
        },
        prefix: {
            marginInlineEnd: 6,
        },
        suffix: {
            marginInlineStart: 6,
        },
        addon: {
            backgroundColor: semantic.fill.subtler.neutral,
            color: semantic.text.neutral,
            border: '1px solid',
            borderColor: semantic.component.input.border,
            padding: {
                small: '6px 8px',
                medium: '6px 8px',
                large: '6px 12px',
                extraLarge: '6px 12px',
            },
            lineHeight: '20px',
        },
        icon: {
            fill: semantic.text.neutral,
        },
        clearIcon: {
            fill: semantic.text.neutral,
            marginRight: 4,
        },
        loadingicon: {
            fill: semantic.text.neutral,
        },
        searchIcon: {
            fill: semantic.text.neutral,
        },
        visibleIcon: {
            fill: semantic.text.stronger.neutral,
        },
        showCount: {
            color: semantic.text.neutral,
            fontSize: 12,
            lineHeight: '16px',
            fontWeight: 400,
        },
        error: {
            borderColor: semantic.border.error,
        },
        warning: {
            borderColor: semantic.border.warning,
        },
        readOnly: {
            color: semantic.text.neutral,
            backgroundColor: semantic.fill.subtler.neutral,
        },
        disabled: {
            color: semantic.state.disable,
            borderColor: semantic.state.subtle.disable,
            backgroundColor: semantic.bg.default,
            error: {
                borderColor: semantic.state.subtle.error.disable,
            },
            warning: {
                // This is not available for now
                // borderColor: semantic.state.subtle.warning.disable,
                borderColor: semantic.state.subtle.warning.hover,
            },
        },
        TextArea: {
            height: {
                small: 48,
                medium: 60,
                large: 72,
                extraLarge: 72,
            },
            border: '1px solid',
            borderColor: semantic.component.input.border,
            color: semantic.text.stronger.neutral,
            placeholderColor: semantic.text.neutral,
            borderRadius: {
                small: '6px',
                medium: '8px',
                large: '10px',
                extraLarge: '12px',
            },
            padding: {
                small: '6px 8px',
                medium: '6px 8px',
                large: '6px 12px',
                extraLarge: '6px 12px',
            },
            lineHeight: {
                small: typography.lineHeight.subtitle,
                medium: typography.lineHeight.body,
                large: '20px' /* typography.fontSize.bodyLarge */,
                extraLarge: '20px' /* typography.fontSize.bodyLarge */,
            },
            backgroundColor: semantic.bg.default,
            allowClear: {
                TextArea: {
                    paddingInlineEnd: 28,
                },
            },
        },
    };
}
